export default "__VITE_ASSET__CJssUyzh__"